// src/components/shared/LoadingSpinner.js
// Composant de chargement - NE PAS MODIFIER

import React from 'react';

const LoadingSpinner = ({ size = 'medium', fullScreen = false, message = '' }) => {
  const sizes = {
    small: '20px',
    medium: '40px',
    large: '60px',
  };

  const spinnerSize = sizes[size] || sizes.medium;

  const styles = {
    container: fullScreen
      ? {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(10, 14, 26, 0.9)',
          zIndex: 9998,
          gap: '16px',
        }
      : {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          gap: '12px',
        },
    spinner: {
      width: spinnerSize,
      height: spinnerSize,
      border: '3px solid rgba(255, 215, 0, 0.15)',
      borderTop: '3px solid #FFD700',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    message: {
      color: '#A0AEC0',
      fontSize: '14px',
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div style={styles.spinner}></div>
      {message && <div style={styles.message}>{message}</div>}
    </div>
  );
};

export default LoadingSpinner;